module.exports = __webpack_public_path__ + "img/bell-icon-blak.d528093e.svg";